import { useMemo } from 'react';
import { useGetList } from 'ra-core';
import { useHasPermission } from '../../auth/useHasPermission';
import { useCurrentUser } from '../../auth/currentUserContext';
import { useIsUnitManager } from '../../auth/useIsUnitManager';

export type Unit = { id: number; name: string };

export const useRestrictedUserUnits = () => {
  const { units } = useCurrentUser();
  const hasAdminAccess = useHasPermission('ADMIN_ACCESS');
  const isUnitAdmin = useIsUnitManager();

  const allUnitsQuery = useGetList<Unit>(
    'units',
    {
      pagination: { page: 1, perPage: 999 },
      sort: { field: 'name', order: 'ASC' },
    },
    { enabled: isUnitAdmin }
  );

  const restrictedUnitIds = useMemo(() => {
    if (!allUnitsQuery.data) return [];

    return units
      .map(
        (unitName) =>
          allUnitsQuery.data.find((unit) => unit.name === unitName)?.id
      )
      .filter((id): id is number => id !== undefined);
  }, [units, allUnitsQuery.data]);

  return {
    hasAdminAccess,
    isUnitAdmin,
    restrictedUnitIds,
    isPending: allUnitsQuery.isPending,
    isError: allUnitsQuery.isError,
    error: allUnitsQuery.error,
    refetch: allUnitsQuery.refetch,
  };
};
